import { createContext } from 'react';

import type { SupportedLanguage } from '@/locales/translations';

export type LanguageOption = {
  value: SupportedLanguage;
  label: string;
};

export type TranslationParams = Record<string, string | number>;

export type LanguageContextValue = {
  language: SupportedLanguage;
  setLanguage: (language: SupportedLanguage) => void;
  t: (key: string, params?: TranslationParams) => string;
  availableLanguages: LanguageOption[];
};

export const LanguageContext = createContext<LanguageContextValue | undefined>(undefined);
